
import * as commonConst from '../common/constants';
import * as exclusiveConst from './constants';
import * as exclusiveApis from '../../services/apis/exclusive';
import * as commonRegionService from '../../services/common/region';

export default {
    [exclusiveConst.CheckDedicatedHostCapacity](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.CheckDedicatedHostCapacity);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
                // console.log(data, 111);
                // if(data.Error || data.dedicatedHost.status != 200) {
                //     reject(data.Error.Message);
                // } else {
                //     resolve(data);
                // }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [exclusiveConst.createExclusive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.CreateDedicatedHostProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.Error || data.dedicatedHost.status != 200) {
                    reject(data.Error.Message);
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            }).then();
        })
    },
    [exclusiveConst.queryExclusive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.QueryDedicatedHostPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(exclusiveConst.ExclusiveSystem, data);
                // let exclusiveRegion = [];
                // let allRegions = _.filter(data.value, ['dataCenterId', '1']);
                // let list = allRegions[0]['regions']
                // _.map(list, (val, idx) => {
                //     if (val.region_code != 'cn-beijing-5') {
                //         exclusiveRegion.push(list[idx]);
                //     }
                // });
                // data = data.data;
                // // console.log(data, 1231);
                // if(data.productTypeList){
                //     _.map(data.productTypeList, (pitem) => {
                //         _.map(pitem.regionList, (ritem) => {
                //             if(ritem.regionCode != 'cn-beijing-5') {
                //                 let hasIt = _.find(exclusiveRegion, ['regionCode', ritem.regionCode]);
                //                 if (!hasIt) {
                //                     exclusiveRegion.push(ritem)
                //                 }
                //             }
                //         })
                //
                //     })
                // }
                // ctx.commit(commonConst.regionList, exclusiveRegion);
                // if(data.productTypeList){
                //     _.map(data.productTypeList, (pitem) => {
                //         _.map(pitem.regionList, (ritem) => {
                //             if(ritem.regionCode != 'cn-beijing-5') {
                //                 exclusiveRegion.push(ritem)
                //             }
                //         })
                //
                //     })
                // }
                // ctx.commit(commonConst.regionList, exclusiveRegion);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },
    [exclusiveConst.getExclusives](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(exclusiveApis.DescribeDedicatedHosts,params);
            console.log(params, 111112222);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(exclusiveConst.getExclusives, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        })
    },
    [exclusiveConst.deleteExclusive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.DeleteDedicatedHost);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve();
            }).catch(e => {
                reject(e);
            });
        })
    },
    [exclusiveConst.calcExclusive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.CalculateDedicatedHostProduct);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.price) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            }).then();
        })
    },
    [exclusiveConst.calcRenew](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.calcRenew);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.code == 200) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            });
        })
    },
    [exclusiveConst.dedicatedRenew](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.dedicatedRenew);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.code == 200) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            });
        })
    },
    [exclusiveConst.renameExclusive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.RenameDedicatedHost);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.Error) {
                    reject(data.Error.Message);
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            }).then();
        })
    },
    //宿主机ID查询计费方式
    [exclusiveConst.QueryBillTypeByDedicatedIds](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.QueryBillTypeByDedicatedIds);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data && data.queryBillTypeByDedicatedIdList.length > 0) {
                    let arr = _.uniq(_.flatten(_.map(data.queryBillTypeByDedicatedIdList, (o) => {
                        return o.billType
                    })));
                    let exclusiveBill = {};
                    _.map(data.queryBillTypeByDedicatedIdList, (obj) => {
                        _.map(arr, (b, k) => {
                            if (!exclusiveBill[b]) {
                                exclusiveBill[b] = [];
                            }
                            if(_.indexOf(obj.billType, arr[k]) > -1) {
                                exclusiveBill[b].push(obj.instanceId);
                            }
                        })
                    });
                    let exclusiveDiscount = _.get(data, 'queryBillTypeByDedicatedIdList[0].discount');
                    ctx.commit(exclusiveConst.QueryBillTypeByDedicatedIds, {
                        exclusiveBill: exclusiveBill,
                        exclusiveDiscount: exclusiveDiscount
                    })
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            }).then();
        })
    },
    //创建试用专属宿主机续费
    [exclusiveConst.tryDedicatedRenew](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.tryDedicatedRenew);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
        })
    },
    //创建试用专属宿主机转正商品接口
    [exclusiveConst.tryDedicatedPositive](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.tryDedicatedPositive);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
        })
    },
    //监控
    [exclusiveConst.exclusiveMonitor](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.exclusiveMonitor);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },


    //专属集群列表
    [exclusiveConst.getDedicatedCluster](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.getDedicatedCluster);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(exclusiveConst.getDedicatedCluster, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //修改集群名称
    [exclusiveConst.modifyclusterName](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.modifyclusterName);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //创建集群
    [exclusiveConst.createDedicatedCluster](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.createDedicatedCluster);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //删除集群
    [exclusiveConst.delDedicatedCluster](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.delDedicatedCluster);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //专属宿主机更改集群
    [exclusiveConst.migrateExclusiveCluster](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.migrateExclusiveCluster);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //设置虚拟核数量
    [exclusiveConst.setVCPU](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.setVCPU);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [exclusiveConst.exclusiveOverview](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.exclusiveOverview);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(exclusiveConst.exclusiveOverview, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [exclusiveConst.DescribeTagKeysV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.DescribeTagKeysV2);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(exclusiveConst.DescribeTagKeysV2, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [exclusiveConst.DescribeTagValuesV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.DescribeTagValuesV2);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(exclusiveConst.DescribeTagValuesV2, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    //专属宿主机绑定标签
    [exclusiveConst.ReplaceResourcesTagsV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.ReplaceResourcesTagsV2);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.Result) {
                    resolve(data);
                } else {
                    reject(data.code);
                }
            }).catch(e => {
                reject(e);
            })
        })
    },
    //专属宿主机解绑标签
    [exclusiveConst.DetachResourceTagsV2](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.DetachResourceTagsV2);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.Result) {
                    resolve(data);
                } else {
                    reject(data.code);
                }
            }).catch(e => {
                reject(e);
            })
        })
    },
    // 调整配置，只有盘类型改变时调用这个接口
    [exclusiveConst.ModifyVolumeType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.ModifyVolumeType);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
    //存储集群模式变更
    [exclusiveConst.ModifyEbsClusterMode](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, exclusiveApis.ModifyEbsClusterMode);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        })
    },
};
